<div class="cms-radio-option"
     [class.cms-radio-option--selected]="selected">
    <span class="cms-radio-option__radio"
          [class.cms-radio-option__radio--selected]="selected"
          aria-hidden="true"></span>
    <span class="cms-radio-option__label">{{ label }}</span>
</div>
